"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMoneyString = exports.formatMoney = exports.RoundingMode = exports.getCurrencySymbol = exports.getCreditCurrencyEqlCode = exports.setCreditCurrencyEqlCode = exports.CREDITS_CURRENCY_CODE = void 0;
const tslib_1 = require("tslib");
exports.CREDITS_CURRENCY_CODE = "CRE";
const CREDIT_CURRENCY_SYMBOL = "Cr";
let CREDIT_CURRENCY_EQL = "USD";
const DEFAULT_LOCALE = "en";
const setCreditCurrencyEqlCode = (code) => (CREDIT_CURRENCY_EQL = code);
exports.setCreditCurrencyEqlCode = setCreditCurrencyEqlCode;
const getCreditCurrencyEqlCode = () => CREDIT_CURRENCY_EQL;
exports.getCreditCurrencyEqlCode = getCreditCurrencyEqlCode;
function getCurrencySymbol(currencyCode, locale = DEFAULT_LOCALE) {
    if (currencyCode.toUpperCase() === exports.CREDITS_CURRENCY_CODE)
        return CREDIT_CURRENCY_SYMBOL;
    const currency = Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode.toUpperCase(),
    })
        .formatToParts(0)
        .find(item => item.type === "currency");
    return (currency && currency.value) || "";
}
exports.getCurrencySymbol = getCurrencySymbol;
var RoundingMode;
(function (RoundingMode) {
    RoundingMode["HALF_EVEN"] = "HALF_EVEN";
    RoundingMode["UP"] = "UP";
})(RoundingMode = exports.RoundingMode || (exports.RoundingMode = {}));
const getFormatter = ({ currencyCode = exports.CREDITS_CURRENCY_CODE, locale = DEFAULT_LOCALE, useGrouping = false, compact = false, minimumFractionDigits, maximumFractionDigits, creditsSymbolTranslator, }) => {
    const formatter = new Intl.NumberFormat(locale, {
        useGrouping,
        notation: compact ? "compact" : undefined,
        currency: currencyCode === exports.CREDITS_CURRENCY_CODE ? CREDIT_CURRENCY_EQL : currencyCode,
        minimumFractionDigits,
        maximumFractionDigits,
        style: "currency",
    });
    if (currencyCode === exports.CREDITS_CURRENCY_CODE) {
        const symbol = creditsSymbolTranslator ? creditsSymbolTranslator(CREDIT_CURRENCY_SYMBOL) : CREDIT_CURRENCY_SYMBOL;
        if (symbol === "") {
            return formatter;
        }
        return new Proxy(formatter, {
            get(target, p) {
                if (p === "format") {
                    return (number) => {
                        const parts = target.formatToParts(Math.abs(number));
                        const origSymbol = (parts.find(i => i.type === "currency") || { value: "" }).value;
                        return target.format(number).replace(origSymbol, symbol);
                    };
                }
                else if (p === "formatToParts") {
                    return (number) => {
                        return target.formatToParts(number).map(part => {
                            if (part.type === "currency") {
                                return Object.assign(Object.assign({}, part), { value: symbol });
                            }
                            return part;
                        });
                    };
                }
                else {
                    return target[p];
                }
            },
        });
    }
    return formatter;
};
const roundAmount = (amount, roundingMode) => {
    if (roundingMode === RoundingMode.UP) {
        amount = Math.ceil(amount * 100) / 100;
    }
    return amount;
};
const formatMoney = (amount, _a = {}) => {
    var { forceNumberSymbol, roundingMode = RoundingMode.HALF_EVEN } = _a, formatterOpts = tslib_1.__rest(_a, ["forceNumberSymbol", "roundingMode"]);
    const moneyParts = getFormatter(formatterOpts).formatToParts(roundAmount(amount, roundingMode));
    let decimal = "", integers = "", fraction = "", compactResult = "", numberSymbol = forceNumberSymbol && amount > 0 ? "+" : "", symbol = "";
    moneyParts.forEach(part => {
        if (part.type === "integer" || part.type === "group") {
            integers += part.value;
        }
        else if (part.type === "decimal") {
            decimal = part.value;
        }
        else if (part.type === "fraction") {
            fraction = part.value;
        }
        else if (part.type === "compact") {
            compactResult = part.value;
        }
        else if (part.type === "currency") {
            symbol = part.value;
        }
        else if (part.type === "minusSign") {
            numberSymbol = part.value;
        }
    });
    return {
        numberSymbol,
        symbol: symbol,
        separator: decimal,
        wholePart: integers,
        fractionalPart: fraction,
        compact: compactResult,
    };
};
exports.formatMoney = formatMoney;
const formatMoneyString = (amount, _a = {}) => {
    var { forceNumberSymbol, roundingMode = RoundingMode.HALF_EVEN, creditsSymbolTranslator } = _a, formatterOpts = tslib_1.__rest(_a, ["forceNumberSymbol", "roundingMode", "creditsSymbolTranslator"]);
    amount = roundAmount(amount, roundingMode);
    const formatter = getFormatter(Object.assign(Object.assign({}, formatterOpts), { creditsSymbolTranslator }));
    let result;
    if (amount > 0 && forceNumberSymbol) {
        const { numberSymbol: numberMinusSymbol } = exports.formatMoney(amount * -1, Object.assign({ forceNumberSymbol,
            creditsSymbolTranslator }, formatterOpts));
        const { numberSymbol } = exports.formatMoney(amount, Object.assign({ forceNumberSymbol,
            creditsSymbolTranslator }, formatterOpts));
        result = formatter.format(amount * -1).replace(numberMinusSymbol, numberSymbol);
    }
    else {
        result = formatter.format(amount);
    }
    return result;
};
exports.formatMoneyString = formatMoneyString;
//# sourceMappingURL=MoneyHelpers.js.map